module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "ecxForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ecxForm,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户等级",
      "prop": "userLevel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "placeholder": "用户等级",
      "disabled": _vm.isCheckStatus
    },
    model: {
      value: (_vm.ecxForm.userLevel),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "userLevel", $$v)
      },
      expression: "ecxForm.userLevel"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有用户",
      "value": "0"
    }
  }, [_vm._v("所有用户")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "普通用户",
      "value": "1"
    }
  }, [_vm._v("普通用户")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "黄金用户",
      "value": "2"
    }
  }, [_vm._v("黄金用户")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "白金用户",
      "value": "3"
    }
  }, [_vm._v("白金用户")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "参与次数",
      "prop": "participateNumber"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "placeholder": "参与次数",
      "disabled": _vm.isCheckStatus
    },
    model: {
      value: (_vm.ecxForm.participateNumber),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "participateNumber", $$v)
      },
      expression: "ecxForm.participateNumber"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "无限制",
      "value": "0"
    }
  }, [_vm._v("无限制")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "一天一次",
      "value": "1"
    }
  }, [_vm._v("一天一次")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "活动期间仅一次",
      "value": "2"
    }
  }, [_vm._v("活动期间仅一次")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "活动期间多次",
      "value": "3"
    }
  }, [_vm._v("活动期间多次")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "关注公众号",
      "prop": "diyihh"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "placeholder": "关注公众号",
      "disabled": _vm.isCheckStatus
    },
    model: {
      value: (_vm.ecxForm.diyihh),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "diyihh", $$v)
      },
      expression: "ecxForm.diyihh"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "无限制",
      "value": "0"
    }
  }, [_vm._v("无限制")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "必须关注公众号",
      "value": "1"
    }
  }, [_vm._v("必须关注公众号")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "必须关注店铺",
      "value": "2"
    }
  }, [_vm._v("必须关注店铺")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "16.5%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "id": "last_step",
      "disabled": _vm.isorgsubmit
    },
    on: {
      "click": function($event) {
        _vm.lastStep('ecxForm')
      }
    }
  }, [_vm._v("上一步\n            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "id": "next_step",
      "disabled": _vm.isorgsubmit
    },
    on: {
      "click": function($event) {
        _vm.nextStep('ecxForm')
      }
    }
  }, [_vm._v("下一步\n            ")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "88%",
      "height": "40px",
      "line-height": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#adadad",
      "width": "150px",
      "height": "40px",
      "text-align": "center",
      "vertical-align": "middle",
      "float": "left"
    }
  }, [_vm._v("\n            用户参与设置\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#adadad",
      "margin-left": "2px",
      "width": "35%",
      "height": "40px",
      "text-align": "center",
      "color": "#adadad",
      "float": "left"
    }
  }, [_vm._v("\n            用户参与设置\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b45ccc5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/activity/ChoiceCondition.vue
// module id = 1029
// module chunks = 2